var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "PanelRow",
    [
      _c(
        "Panel",
        [
          _c("h2", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v(_vm._s(_vm._f("trans")("titles.reports")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "center" }, [
            _c(
              "button",
              {
                staticClass: "btn xl",
                attrs: { type: "button" },
                on: { click: _vm.generate }
              },
              [
                _c("i", { staticClass: "icon" }, [_vm._v("+")]),
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm._f("trans")("loyaltyvenue:reports.generate.title")
                    ) +
                    "\n      "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _vm.list
            ? _c("List", {
                staticClass: "admin-reports-list",
                attrs: { fields: _vm.fields, items: _vm.list },
                on: { clicked: _vm.download }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.items ? _c("Loading") : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a60f54e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a60f54e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/sections/general/AdminReports.vue
// module id = null
// module chunks = 